<script lang="ts">
    import { initCryptcha, resetCryptcha, cryptchaSolution, cryptchaSolutionId } from "../../utils"
    import { location } from "../../store"
    import { getCachedEntries, postDBEntry } from "../../../api"

    export let block: ContentBlockEntry

    let formData: BatteryServiceFormEntry = {
        type: "batteryServiceForm",
        point: block.batteryServiceForm?.point,
        servicePoint: block.batteryServiceForm?.servicePoint,
        language: "",
        siid: "",
        cardBodyColor: "",
        dateOfPurchase: "",
        company: "",
        firstname: "",
        lastname: "",
        street: "",
        zip: "",
        city: "",
        country: block.batteryServiceForm?.countryPrefill || "",
        email: "",
        phone: "",
        description: "",
        optInNewsletter: false,
        _s: "",
        _sId: "",
    }

    let errorMessage = ""
    let success = false
    let loading = false

    const colors: string[] = ["Black", "Blue", "Green", "Orange", "Red", "Neon Lemon", "Pink", "Turquoise"]

    const i18n: { [lang: string]: { [key: string]: string | string[] } } = {
        en: {
            pleaseSelect: "Please select...",
            siid: "SPORTident card number",
            cardBodyColor: "Color",
            dateOfPurchase: "Date of purchase",
            company: "Company / Club",
            firstname: "Firstname",
            lastname: "Lastname",
            street: "Street",
            zip: "ZIP",
            houseNumber: "House number",
            city: "City",
            country: "Country",
            email: "Email",
            phone: "Phone",
            description: "Note",
            optInNewsletter:
                "I subscribe to the SPORTident newsletter to be occasionally informed about new products, interesting events and special offers.",
            allowContact:
                "I agree that the entered data may be used for shipping and to notify about recommended battery changes and important product updates in the future.",
            submit: "Submit",
            colors: ["Black", "Blue", "Green", "Orange", "Red", "Neon Lemon", "Pink", "Turquoise"],
            successMessage: "Your request has been successfully submitted. Thank you!",
        },
        de: {
            pleaseSelect: "Bitte auswählen...",
            siid: "SPORTident-Kartennummer",
            cardBodyColor: "Farbe",
            dateOfPurchase: "Kaufdatum",
            company: "Firma / Verein",
            firstname: "Vorname",
            lastname: "Nachname",
            street: "Straße",
            houseNumber: "Hausnummer",
            zip: "PLZ",
            city: "Ort",
            country: "Land",
            email: "E-Mail",
            phone: "Telefon",
            description: "Anmerkung",
            optInNewsletter:
                "Ich abonnieren den SPORTident-Newsletter, um gelegentlich über neue Produkte, interessante Veranstaltungen und besondere Angebote informiert zu werden.",
            allowContact:
                "Ich bin damit einverstanden, dass die eingetragenen Daten für den Versand und zur Benachrichtigung über empfohlene Batteriewechsel und wichtige Produktaktualisierungen in der Zukunft verwendet werden können.",
            submit: "Absenden",
            colors: ["Schwarz", "Blau", "Grün", "Orange", "Rot", "Neon gelb", "Pink", "Türkis"],
            successMessage: "Ihre Anfrage wurde erfolgreich übermittelt. Vielen Dank!",
        },
        lt: {
            pleaseSelect: "Prašome pasirinkti...",
            siid: "SPORTident kortelės numeris",
            cardBodyColor: "Spalva",
            dateOfPurchase: "Pirkimo data",
            company: "Įmonė / Klubas",
            firstname: "Vardas",
            lastname: "Pavardė",
            street: "Gatvė",
            houseNumber: "Namo numeris",
            zip: "Pašto kodas",
            city: "Miestas",
            country: "Šalis",
            email: "El. paštas",
            phone: "Telefonas",
            description: "Pastaba",
            optInNewsletter:
                "Aš prenumeruoju SPORTident naujienlaiškį, kad būčiau kartais informuotas apie naujus produktus, įdomius renginius ir ypatingas pasiūlymus.",
            allowContact:
                "Sutinku, kad įvesti duomenys gali būti naudojami siuntimui ir pranešimui apie rekomenduojamus baterijų keitimus ir svarbius produkto atnaujinimus ateityje.",
            submit: "Pateikti",
            colors: ["Juoda", "Mėlyna", "Žalia", "Oranžinė", "Raudona", "Neon Lemon", "Rožinė", "Türkis"],
            successMessage: "Jūsų užklausa sėkmingai pateikta. Ačiū!",
        },
        fr: {
            pleaseSelect: "Veuillez sélectionner...",
            siid: "Numéro de carte SPORTident",
            cardBodyColor: "Couleur",
            dateOfPurchase: "Date d'achat",
            company: "Entreprise / Club",
            firstname: "Prénom",
            lastname: "Nom de famille",
            street: "Rue",
            houseNumber: "Numéro de maison",
            zip: "Code postal",
            city: "Ville",
            country: "Pays",
            email: "E-mail",
            phone: "Téléphone",
            description: "Remarque",
            optInNewsletter:
                "Je m'abonne à la newsletter SPORTident pour être informé occasionnellement des nouveaux produits, des événements intéressants et des offres spéciales.",
            allowContact:
                "J'accepte que les données saisies puissent être utilisées pour l'expédition et pour être informé des changements de batterie recommandés et des mises à jour importantes du produit à l'avenir.",
            submit: "Soumettre",
            colors: ["Noir", "Bleu", "Vert", "Orange", "Rouge", "Citron néon", "Rose", "Turquoise"],
            successMessage: "Votre demande a été soumise avec succès. Merci!",
        },
        it: {
            pleaseSelect: "Seleziona...",
            siid: "Numero di carta SPORTident",
            cardBodyColor: "Colore",
            dateOfPurchase: "Data di acquisto",
            company: "Azienda / Club",
            firstname: "Nome",
            lastname: "Cognome",
            street: "Strada",
            houseNumber: "Numero civico",
            zip: "CAP",
            city: "Città",
            country: "Paese",
            email: "E-mail",
            phone: "Telefono",
            description: "Nota",
            optInNewsletter:
                "Iscriviti alla newsletter SPORTident per essere informato occasionalmente sui nuovi prodotti, sugli eventi interessanti e sulle offerte speciali.",
            allowContact:
                "Accetto che i dati inseriti possano essere utilizzati per la spedizione e per essere informato sui cambi di batteria consigliati e sugli importanti aggiornamenti del prodotto in futuro.",
            submit: "Invia",
            colors: ["Nero", "Blu", "Verde", "Arancione", "Rosso", "Limone neon", "Rosa", "Turchese"],
            successMessage: "La tua richiesta è stata inviata con successo. Grazie!",
        },
        pl: {
            pleaseSelect: "Wybierz...",
            siid: "Numer karty SPORTident",
            cardBodyColor: "Kolor",
            dateOfPurchase: "Data zakupu",
            company: "Firma / Klub",
            firstname: "Imię",
            lastname: "Nazwisko",
            street: "Ulica",
            houseNumber: "Numer domu",
            zip: "Kod pocztowy",
            city: "Miasto",
            country: "Kraj",
            email: "E-mail",
            phone: "Telefon",
            description: "Uwaga",
            optInNewsletter:
                "Subskrybuj biuletyn SPORTident, aby być okazjonalnie informowanym o nowych produktach, interesujących wydarzeniach i specjalnych ofertach.",
            allowContact:
                "Zgadzam się, że wprowadzone dane mogą być używane do wysyłki i informowania o zalecanych zmianach baterii oraz ważnych aktualizacjach produktu w przyszłości.",
            submit: "Wyślij",
            colors: [
                "Czarny",
                "Niebieski",
                "Zielony",
                "Pomarańczowy",
                "Czerwony",
                "Cytryna neonowa",
                "Różowy",
                "Turkusowy",
            ],
            successMessage: "Twoje zapytanie zostało pomyślnie przesłane. Dziękuję!",
        },
        po: {
            pleaseSelect: "Por favor seleccione...",
            siid: "Número do cartão SPORTident",
            cardBodyColor: "Cor",
            dateOfPurchase: "Data da compra",
            company: "Empresa / Clube",
            firstname: "Nome",
            lastname: "Sobrenome",
            street: "Rua",
            houseNumber: "Número da casa",
            zip: "CEP",
            city: "Cidade",
            country: "País",
            email: "E-mail",
            phone: "Telefone",
            description: "Nota",
            optInNewsletter:
                "Assine a newsletter SPORTident para ser ocasionalmente informado sobre novos produtos, eventos interessantes e ofertas especiais.",
            allowContact:
                "Concordo que os dados inseridos possam ser usados para envio e para ser informado sobre mudanças de bateria recomendadas e atualizações importantes do produto no futuro.",
            submit: "Enviar",
            colors: ["Preto", "Azul", "Verde", "Laranja", "Vermelho", "Limão Neon", "Rosa", "Turquesa"],
            successMessage: "Seu pedido foi enviado com sucesso. Obrigado!",
        },
        ru: {
            pleaseSelect: "Пожалуйста, выберите...",
            siid: "Номер карты SPORTident",
            cardBodyColor: "Цвет",
            dateOfPurchase: "Дата покупки",
            company: "Компания / Клуб",
            firstname: "Имя",
            lastname: "Фамилия",
            street: "Улица",
            houseNumber: "Дом",
            zip: "Индекс",
            city: "Город",
            country: "Страна",
            email: "Эл. почта",
            phone: "Телефон",
            description: "Примечание",
            optInNewsletter:
                "Подпишитесь на новостную рассылку SPORTident, чтобы время от времени получать информацию о новых продуктах, интересных мероприятиях и специальных предложениях.",
            allowContact:
                "Я соглашаюсь с тем, что введенные данные могут использоваться для отправки и уведомления о рекомендуемых заменах батарей и важных обновлениях продукта в будущем.",
            submit: "Отправить",
            colors: ["Черный", "Синий", "Зеленый", "Оранжевый", "Красный", "Неоновый лимон", "Розовый", "Бирюзовый"],
            successMessage: "Ваш запрос был успешно отправлен. Спасибо!",
        },
        es: {
            pleaseSelect: "Por favor seleccione...",
            siid: "Número de tarjeta SPORTident",
            cardBodyColor: "Color",
            dateOfPurchase: "Fecha de compra",
            company: "Empresa / Club",
            firstname: "Nombre",
            lastname: "Apellido",
            street: "Calle",
            houseNumber: "Número de casa",
            zip: "Código postal",
            city: "Ciudad",
            country: "País",
            email: "Correo electrónico",
            phone: "Teléfono",
            description: "Nota",
            optInNewsletter:
                "Me suscribo al boletín de SPORTident para ser informado ocasionalmente sobre nuevos productos, eventos interesantes y ofertas especiales.",
            allowContact:
                "Acepto que los datos introducidos puedan utilizarse para el envío y para ser informado sobre cambios de batería recomendados y actualizaciones importantes del producto en el futuro.",
            submit: "Enviar",
            colors: ["Negro", "Azul", "Verde", "Naranja", "Rojo", "Lima Neón", "Rosa", "Turquesa"],
            successMessage: "Tu solicitud ha sido enviada exitosamente. ¡Gracias!",
        },
        cz: {
            pleaseSelect: "Prosim vyberte...",
            siid: "Číslo karty SPORTident",
            cardBodyColor: "Barva",
            dateOfPurchase: "Datum nákupu",
            company: "Společnost / Klub",
            firstname: "Jméno",
            lastname: "Příjmení",
            street: "Ulice",
            houseNumber: "číslo domu",
            zip: "PSČ",
            city: "Město",
            country: "Země",
            email: "E-mail",
            phone: "Telefon",
            description: "Poznámka",
            optInNewsletter:
                "Přihlaste se k odběru newsletteru SPORTident, abyste byli občas informováni o nových produktech, zajímavých událostech a speciálních nabídkách.",
            allowContact:
                "Souhlasím s tím, že zadané údaje mohou být použity k odesílání a k informování o doporučených výměnách baterií a důležitých aktualizacích produktu v budoucnosti.",
            submit: "Odeslat",
            colors: ["Černá", "Modrá", "Zelená", "Oranžová", "Červená", "Neonový citrón", "Růžová", "Tyrkysová"],
            successMessage: "Vaše žádost byla úspěšně odeslána. Děkujeme!",
        },
        hu: {
            pleaseSelect: "Kérem válasszon...",
            siid: "SPORTident kártyaszám",
            cardBodyColor: "Szín",
            dateOfPurchase: "Vásárlás dátuma",
            company: "Cég / Klub",
            firstname: "Keresztnév",
            lastname: "Vezetéknév",
            street: "Utca",
            houseNumber: "Házszám",
            zip: "Irányítószám",
            city: "Város",
            country: "Ország",
            email: "E-mail",
            phone: "Telefon",
            description: "Megjegyzés",
            optInNewsletter:
                "Feliratkozom a SPORTident hírlevélre, hogy időnként értesüljek az új termékekről, érdekes eseményekről és különleges ajánlatokról.",
            allowContact:
                "Egyetértek azzal, hogy a megadott adatokat a szállításhoz és a jövőbeni ajánlott elemcserék és fontos termékfrissítések értesítéséhez használják.",
            submit: "Küldés",
            colors: ["Fekete", "Kék", "Zöld", "Narancssárga", "Piros", "Neon citrom", "Rózsaszín", "Türkiz"],
            successMessage: "A kérelme sikeresen elküldve. Köszönöm!",
        },
    }

    // prefered language by browser settings
    const lang = typeof navigator !== "undefined" ? navigator.language.split("-")[0] : "en"
    const _t = i18n[lang] || i18n.en

    function submit(e: Event) {
        e.preventDefault()
        formData.language = lang
        formData.point = block.batteryServiceForm?.point
        formData.servicePoint = block.batteryServiceForm?.servicePoint

        formData.referrer = $location.path
        formData._s = $cryptchaSolution
        formData._sId = $cryptchaSolutionId

        console.log(formData)
        loading = true
        success = false
        errorMessage = ""

        postDBEntry("form", formData)
            .then(() => {
                success = true
                // clear form
                Object.keys(formData).forEach((key) => {
                    if (key !== "type") formData[key] = ""
                })
                accepted = false
                if (typeof window !== "undefined") {
                    setTimeout(() => {
                        success = false
                    }, 5000)
                }
            })
            .catch((err) => {
                console.error(err)
                errorMessage = "An error occurred. Please try again later. (" + err.data?.message + ")"
            })
            .finally(() => {
                loading = false
            })

        resetCryptcha()
    }

    let cryptchaEl: HTMLDivElement

    let accepted = false

    let cryptchaInitialized = false

    $: if (cryptchaEl && !cryptchaInitialized && formData.siid) {
        initCryptcha(cryptchaEl)
        cryptchaInitialized = true
    }
</script>

<div class="container">
    <form on:submit="{submit}">
        <div class="grid tp-l bp-l">
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="siid">{_t["siid"]}<span>*</span></label>
                <input type="text" id="siid" required bind:value="{formData.siid}" />
            </div>
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="cardBodyColor">{_t["cardBodyColor"]}<span>*</span></label>
                <select id="cardBodyColor" bind:value="{formData.cardBodyColor}" required>
                    <option value="" selected disabled>{_t["pleaseSelect"]}</option>
                    {#each colors as color, idx}
                        <option value="{color}">{_t.colors[idx]}</option>
                    {/each}
                </select>
            </div>
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="dateOfPurchase">{_t["dateOfPurchase"]}<span>*</span></label>
                <input type="date" id="dateOfPurchase" required bind:value="{formData.dateOfPurchase}" />
            </div>
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="company">{_t["company"]}</label>
                <input type="text" id="company" bind:value="{formData.company}" />
            </div>
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="firstname">{_t["firstname"]}<span>*</span></label>
                <input type="text" id="firstname" required bind:value="{formData.firstname}" />
            </div>
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="lastname">{_t["lastname"]}<span>*</span></label>
                <input type="text" id="lastname" required bind:value="{formData.lastname}" />
            </div>
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="street">{_t["street"]} / {_t["houseNumber"]}<span>*</span></label>
                <input type="text" id="street" required bind:value="{formData.street}" />
            </div>
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="zip">{_t["zip"]}<span>*</span></label>
                <input type="text" id="zip" required bind:value="{formData.zip}" />
            </div>
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="city">{_t["city"]}<span>*</span></label>
                <input type="text" id="city" required bind:value="{formData.city}" />
            </div>

            <div class="col-md-6 col-12 col-grid border-bottom">
                <!-- Dieses Element ist möglicherweise mit Filterbarem Dropdown? -->
                <label for="country">{_t["country"]}<span>*</span></label>
                {#await getCachedEntries("country", null, "name") then countries}
                    <select id="country" bind:value="{formData.country}" required>
                        <option value="" selected disabled>{_t["pleaseSelect"]}</option>
                        {#each countries as country}
                            <option
                                value="{country.code}"
                                selected="{country.code == block.batteryServiceForm?.countryPrefill}"
                                >{country.name}</option
                            >
                        {/each}
                    </select>
                {/await}
            </div>

            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="email">{_t["email"]}<span>*</span></label>
                <input type="email" id="email" required bind:value="{formData.email}" />
            </div>
            <div class="col-md-6 col-12 col-grid border-bottom">
                <label for="phone">{_t["phone"]}</label>
                <input type="text" id="phone" bind:value="{formData.phone}" />
            </div>
            <div class="col-12 col-grid border-bottom">
                <label for="description">{_t["description"]}</label>
                <textarea id="description" bind:value="{formData.description}"></textarea>
            </div>
            <div class="col-12">
                <input type="checkbox" id="optInNewsletter" bind:checked="{formData.optInNewsletter}" />
                <label class="checkbox-wrap" for="optInNewsletter"><span>{_t["optInNewsletter"]}</span></label>
            </div>
            <div class="col-12">
                <input type="checkbox" id="allowContact" required bind:checked="{accepted}" />
                <label class="checkbox-wrap" for="allowContact"><span>*</span> <span>{_t["allowContact"]}</span></label>
            </div>
            {#if success}
                <div class="col-12 success">
                    <p>{_t["successMessage"]}</p>
                </div>
            {/if}
            {#if errorMessage}
                <div class="col-12 error">
                    <p>{errorMessage}</p>
                </div>
            {/if}
            <div class="col-12">
                <button type="submit" class="btn-primary" disabled="{!$cryptchaSolution || !accepted || loading}"
                    >{_t["submit"]}</button
                >
            </div>
        </div>
        <div bind:this="{cryptchaEl}"></div>
    </form>
</div>

<style lang="less">
    button:disabled {
        opacity: 0.5;
    }

    .success {
        background-color: #d4edda;
        color: #155724;
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 0.25rem;
    }

    .error {
        background-color: #f8d7da;
        color: #721c24;
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 0.25rem;
    }
</style>
